import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  MenuItem,
  IconButton,
  Typography,
  Select,
  Chip,
} from "@mui/material";

import {
  Visibility,
  Delete,
  NotificationsActive,
} from "@mui/icons-material";
import Edit from "@mui/icons-material/Edit";

import { useNavigate } from "react-router-dom";
import deleteConfirm from "../emp/deleteEmp";

const API_URL = "https://api.hr-ebnhaian.cloud/api/v1/centers";

function CenterList() {
  const [centers, setCenters] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();

  /* =========================
     FETCH CENTERS
  ========================= */
  const fetchCenters = () => {
    axios
      .get(API_URL, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setCenters(res.data.data || []);
      })
      .catch((err) => {
        console.error("Error fetching centers:", err);
      });
  };

  useEffect(() => {
    fetchCenters();
  }, []);

  /* =========================
     FILTER
  ========================= */
  const filteredCenters = centers.filter((center) => {
    const name = (center.name || "").toLowerCase();
    const code = (center.code || "").toLowerCase();
    const phone = (center.phone || "").toLowerCase();
    const email = (center.email || "").toLowerCase();

    return (
      (!statusFilter || center.status === statusFilter) &&
      (name.includes(searchTerm.toLowerCase()) ||
        code.includes(searchTerm.toLowerCase()) ||
        phone.includes(searchTerm.toLowerCase()) ||
        email.includes(searchTerm.toLowerCase()))
    );
  });

  /* =========================
     CONTRACT ALERT
  ========================= */
  const isContractExpiring = (contract) => {
    if (!contract?.endDate) return false;
    const today = new Date();
    const diff =
      (new Date(contract.endDate) - today) / (1000 * 60 * 60 * 24);
    return diff <= 30;
  };

  const hasAnyAlert = (center) =>
    isContractExpiring(center.rentalContract) ||
    isContractExpiring(center.fireSafetyContract) ||
    isContractExpiring(center.healthLicense);

  return (
    <Box p={3}>
      <Typography variant="h5" mb={2}>
        Centers
      </Typography>

      {/* ACTION BAR */}
      <Box display="flex" alignItems="center" gap={2} mb={2}>
        <Select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          displayEmpty
          size="small"
        >
          <MenuItem value="">All Status</MenuItem>
          <MenuItem value="ACTIVE">Active</MenuItem>
          <MenuItem value="INACTIVE">Inactive</MenuItem>
        </Select>

        <TextField
          size="small"
          label="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <Button
          variant="contained"
          onClick={() => navigate("/centers/add")}
        >
          Add Center
        </Button>
      </Box>

      {/* TABLE */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: "#1976d2" }}>
            <TableRow>
              <TableCell sx={{ color: "white" }}>
                <input type="checkbox" />
              </TableCell>
              <TableCell sx={{ color: "white" }}>Alert</TableCell>
              <TableCell sx={{ color: "white" }}>Name</TableCell>
              <TableCell sx={{ color: "white" }}>Code</TableCell>
              <TableCell sx={{ color: "white" }}>Phone</TableCell>
              <TableCell sx={{ color: "white" }}>Email</TableCell>
              <TableCell sx={{ color: "white" }}>Address</TableCell>
              <TableCell sx={{ color: "white" }}>Status</TableCell>
              <TableCell sx={{ color: "white" }}>Log</TableCell>
              <TableCell sx={{ color: "white" }}>Details</TableCell>
              <TableCell sx={{ color: "white" }}>Edit</TableCell>
              <TableCell sx={{ color: "white" }}>Delete</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredCenters.map((center) => (
              <TableRow key={center._id}>
                {/* Check */}
                <TableCell>
                  <input type="checkbox" />
                </TableCell>

                {/* Alert */}
                <TableCell>
                  {hasAnyAlert(center) ? (
                    <NotificationsActive color="error" />
                  ) : (
                    "-"
                  )}
                </TableCell>

                {/* Name */}
                <TableCell>{center.name}</TableCell>

                {/* Code */}
                <TableCell>{center.code}</TableCell>

                {/* Phone */}
                <TableCell>{center.phone || "-"}</TableCell>

                {/* Email */}
                <TableCell>{center.email || "-"}</TableCell>

                {/* Address */}
                <TableCell>{center.address || "-"}</TableCell>

                {/* Status */}
                <TableCell>
                  <Chip
                    label={center.status}
                    color={center.status === "ACTIVE" ? "success" : "default"}
                    size="small"
                  />
                </TableCell>

                {/* Log */}
                <TableCell>
                  <IconButton>
                    <Visibility />
                  </IconButton>
                </TableCell>

                {/* Details */}
                <TableCell>
                  <IconButton
                    onClick={() => navigate(`/centers/${center._id}`)}
                  >
                    📁
                  </IconButton>
                </TableCell>

                {/* Edit */}
                <TableCell>
                  <IconButton
                    color="primary"
                    onClick={() => navigate(`/centers/${center._id}/edit`)}
                  >
                    <Edit />
                  </IconButton>
                </TableCell>

                {/* Delete */}
                <TableCell>
                  <IconButton
                    color="error"
                    onClick={() =>
                      deleteConfirm(`${API_URL}/${center._id}`, fetchCenters)
                    }
                  >
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}

            {filteredCenters.length === 0 && (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  No centers found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default CenterList;
